import { apiCall } from "utils/apiClient";

export const listAdminReviews = () =>
  apiCall({
    endpoint: "reviews/admin/list",
    method: "GET",
  });

export const getAdminReview = (reviewId) =>
  apiCall({
    endpoint: `reviews/admin/${reviewId}`,
    method: "GET",
  });

export const updateAdminReviewStatus = (reviewId, status) =>
  apiCall({
    endpoint: `reviews/admin/${reviewId}/status`,
    method: "PUT",
    data: { status },
  });

export const getServiceReviewSummary = (serviceId) =>
  apiCall({
    endpoint: `reviews/admin/service-summary/${serviceId}`,
    method: "GET",
  });

export const listServiceReviewSummaries = () =>
  apiCall({
    endpoint: "reviews/admin/service-summary",
    method: "GET",
  });

export const getReviewsByPartnerId = (partnerId) =>
  apiCall({
    endpoint: `reviews/admin/partner/${partnerId}`,
    method: "GET",
  });

export const listPartnerReviews = () =>
  apiCall({
    endpoint: "reviews/partner",
    method: "GET",
  });
